<template>
    <div>

        <!-- TRANSLATE PDF POPUP -->
        <v-layout row justify-center>
            <v-dialog v-model="isPopupOpen"
                      persistent
                      scrollable
                      max-width="600"
                      content-class="dialog-chatbot-translate-pdf"
                      transition="dialog-bottom-transition">

                <v-card class="component-bg-color">

                    <v-card-title style="justify-content: center; max-height: 55px;">
                        <span  @click="closePopup" class="float-left cursor-pointer" style="position: absolute;left: 15px; top: 15px;">
                            <close-icon :svg-fill-class="'svg-secondary-color'"/>

                        </span>
                        <span class="font-weight-bold">{{text('api.share.page.translatePdf.title')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <v-card class="translate-pdf-container assessment-share-page-btn-action popup-scoring-assessment component-bg-color">

                            <div v-if="getPdfTemplateList.length > 0" class="card__title headline">
                                <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectTemplate')}}</span>
                            </div>

                            <div v-if="getPdfTemplateList.length > 0">
                                <v-flex xs12 sm12 class="no-padding-left">
                                    <div class="pdf-template-list">

                                        <pdf-template-selector-radio-group
                                            :selected-template="selectedPdfTemplate"
                                            @onChangeSelectedTemplate="selectedPdfTemplate = $event.selectedPdfTemplate"
                                        ></pdf-template-selector-radio-group>

                                    </div>
                                </v-flex>
                            </div>

                            <div class="card__title headline">
                                <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectLanguage')}}</span>
                            </div>

                            <div>
                                <v-flex xs12 sm12 class="no-padding-left margin-top-s">

                                    <div class="chatbot-answer-list-edit" style="padding-bottom: 8px;">
                                        <div class="answer-list-content answer-list-generic-question-edit">

                                            <div v-if="getPdfTranslateLanguageList.length > 0" class="answer-items">

                                                <div v-for="(pdfTranslateLanguage, langIndex) in getPdfTranslateLanguageList"
                                                     :key="'key-lang-' + langIndex"
                                                     :class="{'answer-item--disabled': (selectedPdfTemplate === '')}"
                                                     class="answer-item">

                                                    <span @click="(selectedPdfTemplate !== '') ? downloadTranslatedPdf(selectedPdfTemplate, pdfTranslateLanguage) : null;"
                                                          class="answer-item-text"
                                                          :class="{'color-primary' : (selectedPdfTemplate !== '')}"
                                                    >{{findLanguageNameForDisplay(pdfTranslateLanguage)}}</span>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </v-flex>
                            </div>
                        </v-card>

                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import PdfTemplateSelectorRadioGroup
    from "../../../common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";

export default {
    name: 'PdfTemplateSelectionPopup',
    components: {
        CloseIcon,
        PdfTemplateSelectorRadioGroup
    },

    props: {
        isPopupOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedPdfTemplate: ''
        };
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        getPdfTemplateList() {
            return this.getAppPropertyValueArray('PDF_TEMPLATE');
        },
        getPdfTranslateLanguageList() {
            return this.getAppPropertyValueArray('PDF_TRANSLATE_LANGUAGES');
        },
        findTemplateNameForDisplay() {
            return (template) => {
                return (this.text('pdf.template.name.' + template).length > 0)
                    ? this.text('pdf.template.name.' + template)
                    : template;
            };
        },
        findLanguageNameForDisplay() {
            return (langKey) => {
                return (this.text('api.language.name.' + langKey).length > 0)
                    ? this.text('api.language.name.' + langKey.toLowerCase() )
                    : langKey;
            };
        }
    },

    beforeMount() {
        if (this.getPdfTemplateList.length === 1) {
            // If there is only one PDF template, consider it already selected (so it will be automatically selected
            // and no radio buttons for template selection will be displayed).
            this.selectedPdfTemplate = this.getPdfTemplateList[0];
        }
    },

    watch: {
        isPopupOpen(newVal, oldVal) {
            if (oldVal === false && newVal === true) {
                // OPEN POPUP.

                // ----- Set popup height (fix for iPad/Safari) and answer list scrollable area height -----
                this.setPopupHeight();
            }
        }
    },


    mounted() {
        window.addEventListener('resize', this.UtilitiesPlugin.debounce(this.setPopupHeight, 200));

    },

    beforeDestroy() {
        window.removeEventListener('resize', this.UtilitiesPlugin.debounce(this.setPopupHeight, 200));
    },

    methods: {

        /*selectPdfTemplate(selectedTemplate) {
            this.$emit('onSelectPdfTemplate', selectedTemplate);
        },*/

        downloadTranslatedPdf(pdfTemplate, languageKey) {
            this.$emit("onDownloadPdf", {
                pdfTemplate,
                languageKey
            })
        },

        closePopup() {
            this.$emit('onClosePopup');
        },


        /**
         * Compute and set popup height (fix for iPad/Safari?).
         * @return {Promise}
         */
        setPopupHeight() {

            let promise = new Promise((resolve, reject) => {

                let popupElem = document.querySelector(".dialog-chatbot-translate-pdf");
                let newPopupHeight;

                if (window.innerWidth >= 600) {
                    // Medium and big screens.
                    let pageHeaderHeight = document.querySelector(".chatbot-page-header nav.header-pathfinder");
                    if(pageHeaderHeight) {
                        let pageHeaderOffsetHeight = pageHeaderHeight.offsetHeight;
                        newPopupHeight = window.innerHeight - pageHeaderOffsetHeight;
                    }
                }
                else {
                    // Small screens.
                    newPopupHeight = window.innerHeight;
                }

                if (popupElem) {
                    popupElem.style.height = newPopupHeight + "px";
                }
                resolve(newPopupHeight);
            });

            return promise;
        },

    }

}
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .warning-ambulance {
        position:relative;
        background-color: $color-block-background;
        height:auto !important;
        width:100% !important;
        color: $color-headings-text;
        padding: 20px 20px 0 20px;

        ul li {
            list-style-type: none;
        }
    }

    .close-warning {

        padding-bottom: 50px;



        span {

            float: right;
            padding: 10px;

            .icon {
                color: $color-gray;
            }

            &:hover {
                cursor: pointer;
            }
        }


    }

    .warning-actions {
        display: block;
        padding: 20px 0 20px;
        border-top: none !important;

        .continue {
            padding: 0 20px;

            &:hover {
                cursor: pointer;
            }

            .btn {
                border-radius: 20px;

                .btn__content {
                    padding: 7px 65px;
                }
            }
        }
    }

    .no-padding.card {
        border-radius: 20px !important;
    }

    h2.title {
        font-weight: $font-weight-bold;
       // color: $color-brand-primary;
        font-size: $font-size-big;
    }

.pf-urgent-popup-texts {
   max-height: 65vh;
    overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/TranslatePdfPopup.vue